/**
 * Minimalerei — InteressierterBesuch (Meta Custom-Event)
 *
 * Löst "InteressierterBesuch" aus wenn Besucher auf einer Produktseite
 * sowohl eine Mindest-Verweildauer erreicht (nur aktive Tab-Zeit)
 * ALS AUCH sich konkret mit dem Produkt beschäftigt hat (gescrollt
 * zum Kaufblock, oder Produktgalerie wechselt).
 *
 * Einmal pro Besuch (sessionStorage). Nur bei Marketing-Zustimmung.
 * Teilt Pixel-Init mit mp-zepto-guard.js (window.MpMeta.ensureFbq),
 * kein doppelter PageView.
 *
 * Nur auf Produktseiten laden — main-product.liquid hängt den
 * <script>-Tag mit defer ein (nach mp-zepto-guard.js).
 *
 * Teil C (CAPI-Server) nutzt dieselbe event_id über
 * Shopify.analytics.publish('interessierter_besuch', ...) — passiert
 * zusätzlich zum fbq-Call.
 */

(function () {
  'use strict';

  // ============================================================
  // Konstanten (oben, damit später ohne Suchen anpassbar)
  // ============================================================
  var MP_IB_MIN_SECONDS = 40;
  var MP_IB_SCROLL_RATIO = 0.5;
  var SESSION_KEY = 'mp_ib_sent';
  var EVENT_NAME = 'InteressierterBesuch';
  var ANALYTICS_EVENT = 'interessierter_besuch';
  var PRODUCT_DATA_ID = 'mp-product-data';

  // Debug-Logging via ?mp_debug=1
  var DEBUG = (function () {
    try { return new URLSearchParams(window.location.search).has('mp_debug'); }
    catch (err) { return false; }
  })();
  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[mp-ib]');
    try { console.log.apply(console, args); } catch (err) {}
  }

  // ============================================================
  // Early-Exit: schon in dieser Session gefeuert?
  // ============================================================
  function alreadySent() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; }
    catch (err) { return false; }
  }
  function markSent() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (err) {}
  }
  if (alreadySent()) {
    log('skip: schon in dieser session gefeuert');
    return;
  }

  // ============================================================
  // Produkt-Daten
  // ============================================================
  function readProductData() {
    var el = document.getElementById(PRODUCT_DATA_ID);
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (err) {
      log('product-data JSON parse failed', err);
      return null;
    }
  }
  var product = readProductData();
  if (!product) {
    log('skip: keine produkt-daten gefunden');
    return;
  }

  // ============================================================
  // Zustände & Trigger-Logik
  // ============================================================
  var timeReached = false;
  var scrollReached = false;
  var galleryReached = false;
  var fired = false;

  // Aktive-Sekunden-Zähler (nur bei sichtbarem Tab).
  var visibleSince = null;
  var accumulatedMs = 0;
  var timeTimeout = null;

  function elapsedSeconds() {
    var now = accumulatedMs;
    if (visibleSince !== null) now += Date.now() - visibleSince;
    return Math.floor(now / 1000);
  }

  function startVisibilityClock() {
    if (visibleSince !== null || timeReached) return;
    visibleSince = Date.now();
    var remainingMs = (MP_IB_MIN_SECONDS * 1000) - accumulatedMs;
    if (remainingMs <= 0) {
      timeReached = true;
      log('time reached (immediate)');
      tryFire();
      return;
    }
    timeTimeout = setTimeout(function () {
      if (visibleSince === null) return;
      accumulatedMs += Date.now() - visibleSince;
      visibleSince = null;
      timeReached = true;
      log('time reached nach', elapsedSeconds(), 's');
      tryFire();
    }, remainingMs);
  }

  function pauseVisibilityClock() {
    if (visibleSince === null) return;
    accumulatedMs += Date.now() - visibleSince;
    visibleSince = null;
    if (timeTimeout !== null) {
      clearTimeout(timeTimeout);
      timeTimeout = null;
    }
    log('tab hidden — pause bei', elapsedSeconds(), 's');
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      log('tab visible — resume bei', elapsedSeconds(), 's');
      startVisibilityClock();
    } else {
      pauseVisibilityClock();
    }
  });

  if (document.visibilityState === 'visible') {
    startVisibilityClock();
  }

  // ============================================================
  // Scroll-Logik (B1): Scrolltiefe ≥ 50% ODER Buy-Button sichtbar
  // ============================================================
  function throttle(fn, wait) {
    var last = 0;
    var pending = null;
    return function () {
      var now = Date.now();
      var ctx = this, args = arguments;
      var remaining = wait - (now - last);
      if (remaining <= 0) {
        last = now;
        if (pending) { clearTimeout(pending); pending = null; }
        fn.apply(ctx, args);
      } else if (!pending) {
        pending = setTimeout(function () {
          last = Date.now();
          pending = null;
          fn.apply(ctx, args);
        }, remaining);
      }
    };
  }

  function markScrollReached(reason) {
    if (scrollReached) return;
    scrollReached = true;
    log('scroll/buy-block reached:', reason);
    window.removeEventListener('scroll', scrollHandler);
    tryFire();
  }

  function checkScrollRatio() {
    var scrollHeight = document.documentElement.scrollHeight;
    var viewportHeight = window.innerHeight;
    var maxScroll = scrollHeight - viewportHeight;
    if (maxScroll <= 0) {
      // Seite ist kürzer als der Viewport → gilt als "ganz gesehen".
      markScrollReached('page shorter than viewport');
      return;
    }
    var ratio = (window.scrollY + viewportHeight) / scrollHeight;
    if (ratio >= MP_IB_SCROLL_RATIO) {
      markScrollReached('scroll-ratio ' + ratio.toFixed(2));
    }
  }
  var scrollHandler = throttle(checkScrollRatio, 200);
  window.addEventListener('scroll', scrollHandler, { passive: true });

  // Buy-Button-/Varianten-Block via IntersectionObserver.
  if ('IntersectionObserver' in window) {
    var buyBlock = document.querySelector(
      '.buy-box__atc, [name="add"], .product-form__buttons, .buy-box__action-row, .buy-box__product-form'
    );
    if (buyBlock) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].intersectionRatio >= 0.5) {
            markScrollReached('buy-block ≥50% sichtbar');
            io.disconnect();
            return;
          }
        }
      }, { threshold: [0.5] });
      io.observe(buyBlock);
    }
  }

  // ============================================================
  // Galerie-Logik (B2): zusätzliches Bild angesehen
  // ============================================================
  function markGalleryReached(reason) {
    if (galleryReached) return;
    galleryReached = true;
    log('gallery interaction:', reason);
    tryFire();
  }

  // Thumbnail-/Pfeil-Klicks: Minimalerei-Gallery setzt diese Attribute.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-gallery-thumb]')) {
      markGalleryReached('thumbnail-click');
      return;
    }
    if (e.target.closest('[data-gallery-prev], [data-gallery-next]')) {
      markGalleryReached('arrow-click');
      return;
    }
  }, { passive: true, capture: true });

  // Swipe/Fade-Wechsel beobachten: wenn ein anderer Slide .is-active
  // wird als der initiale (data-media-id ändert sich).
  (function watchActiveSlide() {
    var activeItem = document.querySelector('.m-gallery__item.is-active, [data-gallery-item].is-active');
    if (!activeItem || !activeItem.parentNode) return;
    var initialId = activeItem.getAttribute('data-media-id') || activeItem.getAttribute('data-gallery-item');
    var mo = new MutationObserver(function () {
      var current = activeItem.parentNode.querySelector('.is-active');
      if (!current) return;
      var currentId = current.getAttribute('data-media-id') || current.getAttribute('data-gallery-item');
      if (currentId && currentId !== initialId) {
        markGalleryReached('slide-change (' + initialId + ' → ' + currentId + ')');
        mo.disconnect();
      }
    });
    mo.observe(activeItem.parentNode, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  })();

  // Zoom/Lightbox: Shopify's product-modal öffnet via media-gallery.js.
  // Dafür hört das Modal auf 'click' seines Trigger-Buttons oder
  // bekommt open-Attribut gesetzt. Beobachten: zusätzlich Clicks auf
  // den Zoom-Button bzw. das Hauptmedia-Element.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    // Shopify-Standard Modal-Trigger
    if (e.target.closest('[data-product-media-type-image]') ||
        e.target.closest('.product__media--open-modal')) {
      markGalleryReached('modal-open-click');
    }
  }, { passive: true, capture: true });

  // ============================================================
  // Senden
  // ============================================================
  function engagementLabel() {
    if (scrollReached && galleryReached) return 'both';
    if (galleryReached) return 'gallery';
    return 'scroll';
  }

  function makeEventId() {
    var rnd = Math.random().toString(36).slice(2, 8);
    return 'ib_' + product.id + '_' + Date.now() + '_' + rnd;
  }

  function sendEvent() {
    var eventId = makeEventId();
    var seconds = elapsedSeconds();
    var engagement = engagementLabel();

    var payload = {
      product_id: String(product.id),
      handle: product.handle,
      name: product.name,
      category: product.category,
      value: product.price,
      currency: 'EUR',
      engagement: engagement,
      seconds: seconds,
      event_id: eventId
    };

    // (1) Shopify Customer Events — für spätere CAPI-Server-Spiegel.
    if (window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish(ANALYTICS_EVENT, payload);
      } catch (err) { log('shopify analytics publish failed', err); }
    }

    // (2) First-Party fbq via geteiltem ensureFbq aus mp-zepto-guard.js.
    if (!window.MpMeta || typeof window.MpMeta.ensureFbq !== 'function') {
      log('skip fbq: window.MpMeta.ensureFbq nicht verfügbar');
      fired = false;
      return;
    }
    window.MpMeta.withCustomerPrivacy(function () {
      if (!window.MpMeta.marketingAllowed()) {
        log('skip fbq: keine marketing-zustimmung');
        // KEIN markSent — bei nachträglichem Opt-In soll
        // visitorConsentCollected das Event nachfeuern können.
        fired = false;
        return;
      }
      window.MpMeta.ensureFbq(function () {
        try {
          window.fbq('trackCustom', EVENT_NAME, {
            content_ids: [String(product.id)],
            content_name: product.name,
            content_type: 'product',
            content_category: product.category,
            value: product.price,
            currency: 'EUR',
            engagement: engagement,
            seconds: seconds
          }, { eventID: eventId });
          log('fbq fired:', EVENT_NAME, '(engagement=' + engagement +
              ', seconds=' + seconds + ', event_id=' + eventId + ')');
          // Erst JETZT als gesendet markieren — nach echtem fbq-Call.
          markSent();
        } catch (err) {
          log('fbq call failed', err);
          fired = false;
        }
      });
    });
  }

  function tryFire() {
    if (fired) return;
    if (!timeReached) return;
    if (!scrollReached && !galleryReached) return;
    fired = true;

    // Verzögert in sendEvent-Pipeline: zunächst Zustimmung prüfen.
    // Wenn Zustimmung nicht da ist, markieren wir NICHT als sent —
    // damit nachträgliches Opt-In via visitorConsentCollected noch
    // feuern kann (siehe unten).
    if (!window.MpMeta || typeof window.MpMeta.withCustomerPrivacy !== 'function') {
      // Helpers noch nicht geladen → kurz polling (max 2s).
      var tries = 0;
      var iv = setInterval(function () {
        if (window.MpMeta && typeof window.MpMeta.withCustomerPrivacy === 'function') {
          clearInterval(iv);
          sendEvent();
        } else if (++tries > 20) {
          clearInterval(iv);
          log('MpMeta nicht verfügbar nach 2s — event verloren');
          fired = false;  // zurücksetzen damit späteres Senden möglich bleibt
        }
      }, 100);
      return;
    }
    sendEvent();
  }

  // Nachträgliche Zustimmung: wenn alle Bedingungen schon erfüllt,
  // aber damals keine Zustimmung da war, feuert dieser Hook das Event
  // beim Opt-In nach.
  document.addEventListener('visitorConsentCollected', function () {
    if (alreadySent()) return;
    if (!timeReached) return;
    if (!scrollReached && !galleryReached) return;
    log('zustimmung nachträglich erteilt → nachfeuern');
    fired = false;
    sendEvent();
  });

  log('ready. min_seconds=' + MP_IB_MIN_SECONDS +
      ', scroll_ratio=' + MP_IB_SCROLL_RATIO +
      ', product=' + product.handle);
})();
